var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recentArrivalArea"},[_c('h2',[_vm._v("現在のお問い合せ状況")]),_c('ul',{domProps:{"innerHTML":_vm._s(_vm.arrivalHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }